import React from "react";
import SwaggerUI from "swagger-ui-react";
import "swagger-ui-react/swagger-ui.css";
import spec from "./api/BlueXAPI.json";

const App = () => <SwaggerUI spec={spec} />;

export default App;
